import { configureStore } from "@reduxjs/toolkit";
import searchQueryReducer from "../features/searchQuery/searchQuerySlice";
import ingredientsInputReducer from "../features/ingredientsInput/ingredientsInputSlice";
import ingredientsListReducer from "../features/ingredientsList/ingredientsListSlice";
import searchResultsReducer from "../features/searchResults/searchResultsSlice";

export const store = configureStore({
  reducer: {
    searchQuery: searchQueryReducer,
    ingredientsInput: ingredientsInputReducer,
    ingredientsList: ingredientsListReducer,
    searchResults: searchResultsReducer,
  },
});
